export default (function (value) {
  return value instanceof Map;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isMap.js
// module id = 227
// module chunks = 0